Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Pagination3982139484",
  {"root":"Pagination3982139484--root","buttonTransition":"Pagination3982139484--buttonTransition","pageButtonRules":"Pagination3982139484--pageButtonRules","defaultTextFont":"\"{theme: 'Body-M', size: '16px'}\"","defaultMobileFont":"\"{theme: 'Body-M', size: '14px'}\"","defaultTextFontColor":"color-5","defaultSelectedTextFontColor":"color-8","defaultDisabledTextFontColor":"color-3","TextFont":"--overridable","TextFontColor":"--overridable","SelectedTextFontColor":"--overridable","DisabledTextFontColor":"--overridable"},
  "",
  7,
  "Pagination3982139484"
);

